import DataHealthPage, {
  dataHealthQuery,
} from "@app/pages/data-health/data-health-page";
import type { dataHealthPage_Query } from "@app/queries/dataHealthPage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/data-health")({
  loader: () =>
    loadQuery<dataHealthPage_Query>(
      environment,
      dataHealthQuery,
      {},
      { fetchPolicy: "store-or-network" }
    ),
  head: () => pageHead("Data health"),
  component: DataHealthRoute,
});

function DataHealthRoute() {
  const queryRef = Route.useLoaderData();

  return (
    <ErrorBoundary
      fallback={
        <div className="p-6 text-red-500">Error loading data health</div>
      }
    >
      <Suspense
        fallback={
          <div className="p-6 text-gray-500">
            Auditing statement coverage...
          </div>
        }
      >
        <DataHealthPage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
